<div class="d-block d-lg-none">
  <fgb-page-header
    [pageTitle]="'account.page.title'"
    [backButtonLink]="'/'"
    [showQr]="!isSuiteOrPts"
    [showBalance]="!isSuiteOrPts"
  ></fgb-page-header>
</div>

<ng-container *notInPopulation="[populations.Pts, populations.Suite]"
  ><div class="full-page-container">
    <fgb-banner [title]="'account.activity.page.title' | translate"></fgb-banner>

    <fgb-account-nav></fgb-account-nav>

    <div class="container mt-3 mt-lg-4">
      <div class="points-history">
        <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Suite]">
  <ng-container *ifScreenSize="screenType.Mobile">
    <fgb-banner [title]="'account.activity.page.title' | translate"></fgb-banner>

    <fgb-account-nav></fgb-account-nav>

    <div class="container mt-3 mt-lg-4">
      <div class="points-history">
        <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
      </div>
    </div>
  </ng-container>
  <ng-container *ifScreenSize="screenType.Desktop">
    <fgb-not-found-page></fgb-not-found-page>
  </ng-container>
</ng-container>

<ng-container *inPopulation="[populations.Pts]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
